module.exports = __webpack_public_path__ + "img/programmeLogo.330723fa.png";